import {createContext, useContext} from "react";

/**
 * Präsentationsmodus (Auftrag #59): verfügbare Höhe für die Grafik einer
 * Folie in Pixeln - gemessen aus dem tatsächlichen Fenster, nicht fest
 * hinterlegt. null, solange noch nicht gemessen (dann gelten die
 * Standardhöhen der Diagramme).
 */
export const FolienHoeheKontext = createContext({inhalt: null, grafik: null, nummer: null});

export function useGrafikHoehe() {
    return useContext(FolienHoeheKontext).grafik;
}
